import React from "react";
import { Text, View, StyleSheet, Image, Font, Document, Page } from "@react-pdf/renderer";
import snapshotGroupImg from "../../Assets/Images/snapshotGroupImg.png";
const LatoRegular = require("../../Assets/Fonts/Lato-Font/Lato-Regular.ttf");
const LatoBold = require("../../Assets/Fonts/Lato-Font/Lato-Bold.ttf");

Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  coverSection: {
    margin: "5px",
    padding: "5px",
    textAlign: "left",
    display: "flex",
    alignItems: "flex-start",
    fontFamily: "Lato",
  },
  title: {
    marginBottom: "20px",
    fontSize: "18px",
    fontWeight: 700,
    lineHeight: "18px",
    color: "#426B88",
    fontFamily: "Lato",
    textAlign: "left",
  },
  details: {
    color: "#426B88",
    fontSize: "12px",
    fontWeight: 700,
    lineHeight: "18px",
    marginBottom: 5,
  },
  image: {
    width: "100%",
    maxWidth: 600,
    marginTop: 20,
    alignSelf: "center",
  },
  noteContainer: {
    marginTop: 10,     
    paddingLeft: 6,   
  },
  
  noteBold: {
    fontSize: 12,
    fontWeight: 700, 
    color: "#245775",
  },
  
  noteText: {
    fontSize: 12,
    fontWeight: 400, 
    color: "#426B88", 
    lineHeight: 18,    
    letterSpacing: 0,  
  },
  
});

const AboutGroupReportSecond = ({img, showNote }) => (
  <View>
    <View style={styles.coverSection}>
      <Text style={styles.title}>YOUR GROUP SNAPSHOT RESULTS:</Text>

      {/* Group Details */}
      <Text style={styles.details}>1. Team Name: &lt;Team Name&gt;</Text>
      <Text style={styles.details}>2. Organization: &lt;Organization/Company Name&gt;</Text>
      <Text style={styles.details}>3. Group/Team ID: &lt;Group ID/Tag&gt;</Text>
      <Text style={styles.details}>4. Consultant: &lt;Consultant Full Name&gt;</Text>
      <Text style={styles.details}>5. Assessment: Individuals</Text>

      {/* Image */}
      {img && <Image src={img} style={styles.image} />}
      {showNote && (
        <View style={styles.noteContainer}>
        <Text>
          <Text style={styles.noteBold}>Note:</Text>  
          <Text style={styles.noteText}> Your group's profile reflects an even distribution across the Heart and Soul quadrants.</Text>
        </Text>
      </View>      
        )}
    </View>
  </View>
);

export default AboutGroupReportSecond
